export default "__VITE_ASSET__1N38TNiW__"